import {Component, inject, OnInit} from '@angular/core';
import {CarouselComponent} from "../../../assets/shared/components/carousel/carousel.component";
import {PaymentService} from "../../core/services/payment/payment.service";
import {Carousel} from "../../core/interface/carousel";
import {OwlOptions} from "ngx-owl-carousel-o";
import {ActivatedRoute, Router} from "@angular/router";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
@UntilDestroy()
@Component({
  selector: 'unsubscription',
  imports: [
    CarouselComponent
  ],
  standalone: true,
  templateUrl: './unsubscription.component.html',
  styleUrl: './unsubscription.component.scss'
})
export class UnsubscriptionComponent {
  private paymentService = inject(PaymentService);
  carouselInfo: Carousel[] | undefined
  message: string = 'Вы отменили подписку.';

  subMessage: string = 'На электронную почту вам будет отправлено письмо с подтверждением факта отписки от ежемесячных платежей.';
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navText: [
      '<img src="assets/images/ul-kit/left-arrow.svg">',
      '<img src="assets/images/ul-kit/right-arrow.svg">'
    ],

    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    },
    nav: true
  }


  constructor() {
    this.getCarouselInfo()
  }

  getCarouselInfo() {
    this.paymentService.getCarouselInfo('c').pipe(untilDestroyed(this)).subscribe(carousel => {
      this.carouselInfo = carousel
    })
  }

}
